export const PLAYLISTS_CONTRIBUTOR_ROLES = [
    {
        code: 'OWNER',
        name: 'playlists.contributors.roles.primary'
    }, {
        code: 'EDITOR',
        name: 'playlists.contributors.roles.editor'
    }, {
        code: 'VIEWER',
        name: 'playlists.contributors.roles.viewer'
    }
].sort((a, b) => a.code > b.code ? 1 : -1)


export const PLAYLISTS_TYPES = [
    {
        code: 'USER',
        name: 'playlists.type.user'
    }, {
        code: 'EDITORIAL',
        name: 'playlists.type.editorial'
    }
]
